import requestAction from '../../utils/requestAction'

export const fetchSchools = (params: string) =>
  requestAction('SCHOOL_LIST', params)(`schools`, 'GET')
